<template>
    <div class="home-page">
        <!-- 顶部 Banner -->
        <div
            class="hero"
            :style="{ backgroundImage: `linear-gradient(120deg, rgba(30, 70, 120, 0.35), rgba(20, 40, 70, 0.25)), url(${bannerUrl})` }"
        >
            <div class="hero-mask"></div>
            <button
                class="hero-guide-btn"
                type="button"
                @click="goUsageGuide"
            >
                使用指南
            </button>
            <img class="hero-logo" :src="logoUrl" alt="东朔空间" />
            <p class="hero-title">东朔空间·会议室服务</p>
        </div>

        <!-- 推荐列表 -->
        <div class="panel">
            <div class="panel-header">
                <span class="panel-title">为您推荐附近会议室</span>
                <button class="panel-link" type="button" @click="goAllRooms">
                    全部会议室
                    <span class="panel-link-arrow" aria-hidden="true">›</span>
                </button>
            </div>

            <div
                v-for="room in roomList"
                :key="room.id"
                class="room-card"
                @click="goDetail(room)"
            >
                <img class="room-cover" :src="room.cover" :alt="room.name" />
                <div class="room-body">
                    <div class="room-name">{{ room.name }}<template v-if="room.floor">({{ room.floor }})</template></div>
                    <div class="room-meta">{{ room.location }}</div>
                    <div class="room-meta">开放时间：{{ room.openTime }}</div>
                    <div class="room-tags">
                        <span
                            v-for="(tag, index) in room.tags"
                            :key="index"
                            class="room-tag"
                        >{{ tag }}</span>
                    </div>
                    <div class="room-bottom">
                        <div class="room-price">
                            <span class="price-origin">¥180/小时</span>
                            <span class="price-discount">优惠后</span>
                            <span class="price-now">¥0</span>
                        </div>
                        <button class="book-btn" type="button" @click.stop="goBook(room)">
                            立即预约
                            <span class="book-arrow">›</span>
                        </button>
                    </div>
                </div>
            </div>

            <div v-if="!roomList.length && !listLoading" class="empty">附近暂无相关会议室</div>
        </div>
    </div>
</template>

<script>

import { getWeChatInitConfigRequest, searchRoomsRequest } from '@/request/api';
import { getRandomStr, isUnauthorizedError } from '@/tools/utils';
import scrollKeep from '@/tools/scrollKeep';
import { getSignUrl } from '@/tools/wxAuth';
import placeholderImage from '@/assets/icon_placeholderImage.png';
import logoUrl from '@/assets/icon_logo_white.png';
import { Toast } from 'vant';


export default {
    name: 'homeView',
    mixins: [scrollKeep('homeView')],
    data() {
        return {
            bannerUrl: '/static/rooms/banner.jpg',
            logoUrl,
            // 经度
            longitude: 0,
            // 纬度
            latitude: 0,
            hasLocation: false,
            listLoading: false,
            roomList: [],
            placeholderImage,
        }
    },

    mounted() {
        this.fetchRoomList();
        this.getWeChatInitConfig();
        window.addEventListener('user-info-updated', this.onUserInfoUpdated);
    },

    beforeDestroy() {
        window.removeEventListener('user-info-updated', this.onUserInfoUpdated);
    },

    methods: {
        onUserInfoUpdated() {
            this.fetchRoomList();
        },

        getWeChatInitConfig() {
            let param = {
                noncestr: getRandomStr(16),
                timestamp: Math.floor(Date.now() / 1000),
                url: getSignUrl(),
            }
            let that = this;
            getWeChatInitConfigRequest(param).then(res => {
                console.log('获取微信初始化配置成功--->', res.data);
                wx.config({
                    debug: false,
                    appId: 'wx737465118bfeef99',
                    timestamp: param.timestamp,
                    nonceStr: param.noncestr,
                    signature: res.data,
                    jsApiList: ['getLocation'],
                });
                setTimeout(() => {
                    wx.ready(function () {
                        console.log('微信初始化成功--->');
                        wx.getLocation({
                            type: 'wgs84',
                            success: (res) => {
                                console.log('获取地理位置成功--->', res);
                                const lng = parseFloat(res.longitude)
                                const lat = parseFloat(res.latitude)
                                that.longitude = lng
                                that.latitude = lat
                                that.hasLocation = true
                                that.fetchRoomList()
                            },
                            fail: () => {
                                that.$toast && that.$toast('地理位置获取失败');
                            },
                        })
                    });
                }, 500);
                
            }).catch(err => {
                console.log('获取微信初始化配置失败--->', err);
            });
        },

        buildSearchParams() {
            const params = {}
            if (this.hasLocation) {
                params.lng = this.longitude
                params.lat = this.latitude
            }
            return params
        },
        extractResponseList(res) {
            if (Array.isArray(res)) return res
            if (res && Array.isArray(res.data)) return res.data
            if (res && res.data && Array.isArray(res.data.list)) return res.data.list
            if (res && Array.isArray(res.list)) return res.list
            return []
        },
        parseRoomEquiptTags(equipt) {
            const raw = String(equipt || '').trim()
            if (!raw) return []
            return raw
                .split(/[;；]/)
                .map((part) => part.trim())
                .filter(Boolean)
                .slice(0, 2)
        },
        resolveCoverUrl(url) {
            const IMAGE_BASE = 'https://meetingroom.shdspf.cn'
            const raw = String(url || '').trim()
            if (!raw) return ''
            if (/^https?:\/\//i.test(raw)) return raw
            if (raw.startsWith('//')) return `https:${raw}`
            const path = raw.startsWith('/') ? raw : `/${raw}`
            return `${IMAGE_BASE}${path}`
        },
        mapRoomItem(item) {
            if (!item || typeof item !== 'object') return null
            const id = item.roomId != null ? item.roomId : item.id
            const buildingName = String(item.buildingName || '').trim()
            const floor = item.floor != null && String(item.floor).trim() !== ''
                ? String(item.floor).trim()
                : ''
            const tags = []
            if (item.capacity != null && item.capacity !== '') {
                tags.push(`可容纳${item.capacity}人`)
            }
            tags.push(...this.parseRoomEquiptTags(item.roomEquipt || item.roomEquip))
            const price = item.price != null ? item.price : 0
            const originPrice = item.originPrice != null ? item.originPrice : item.originalPrice
            return {
                id,
                name: item.name || item.roomName || '未命名会议室',
                floor,
                location: buildingName || '—',
                openTime: item.openTime || item.openHours || '09:00-18:00',
                tags,
                originPrice: originPrice != null ? originPrice : price,
                price,
                cover: this.resolveCoverUrl(item.smallPic) || this.placeholderImage,
                adminPhone: String(item.adminPhone || '').trim(),
            }
        },
        fetchRoomList() {
            const params = this.buildSearchParams()
            this.listLoading = true
            Toast.loading({
                message: '正在加载数据',
                forbidClick: true,
                duration: 0,
            })
            searchRoomsRequest(params)
                .then((res) => {
                    if (params.lng && params.lat) {
                        this.roomList = this.extractResponseList(res)
                        .map((item) => this.mapRoomItem(item))
                        .filter((room) => room && room.id != null)
                    }else {
                        this.roomList = this.extractResponseList(res)
                        .map((item) => this.mapRoomItem(item))
                        .filter((room) => room && room.id != null)
                        .slice(0, 20)
                    }
                })
                .catch((err) => {
                    if (isUnauthorizedError(err)) return
                    this.roomList = []
                    const msg = (err && (err.message || err.msg)) || '获取会议室列表失败'
                    this.$toast && this.$toast(msg)
                })
                .finally(() => {
                    this.listLoading = false
                    Toast.clear()
                })
        },
        isLoggedIn() {
            try {
                return !!JSON.parse(localStorage.getItem('userInfo') || 'null')
            } catch (e) {
                return false
            }
        },
        goLogin() {
            this.$router.push('/login')
        },
        goAllRooms() {
            this.$router.push({
                path: '/home/meetingRoomList',
                query: {
                    lng: this.longitude,
                    lat: this.latitude,
                },
            })
        },
        goUsageGuide() {
            this.$router.push('/home/customerUsageGuide')
        },
        goSelectTime(room) {
            if (!this.isLoggedIn()) {
                this.goLogin()
                return
            }
            this.$router.push({
                path: '/home/selectMeetingRoomTimeSlot',
                query: {
                    id: room.id,
                    name: room.name,
                    location: room.location,
                    openTime: room.openTime,
                    price: room.price,
                    originPrice: room.originPrice,
                    cover: room.cover,
                    tags: (room.tags || []).join(','),
                    adminPhone: room.adminPhone || '',
                },
            })
        },
        goDetail(room) {
            this.goSelectTime(room)
        },
        goBook(room) {
            this.goSelectTime(room)
        },
    },
}
</script>

<style scoped>
.home-page {
    min-height: calc(100vh - 1.2rem - env(safe-area-inset-bottom));
    background: #eef3f9;
    /* 列表底部少量间距；tabBar 高度由 MainTab placeholder 预留 */
    padding-bottom: 0.2rem;
    box-sizing: border-box;
}

.hero {
    position: relative;
    height: 3.2rem;
    background-color: #8eadc8;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    overflow: hidden;
}

.hero-mask {
    position: absolute;
    inset: 0;
    background: linear-gradient(180deg, rgba(15, 40, 70, 0.15) 0%, rgba(15, 40, 70, 0.05) 55%, transparent 100%);
}

.hero-guide-btn {
    position: absolute;
    z-index: 2;
    top: calc(0.3rem + env(safe-area-inset-top, 0px));
    right: 0rem;
    padding: 0.1rem 0.22rem;
    border-radius: 0.32rem 0 0 0.32rem;
    background: #2b7de9;
    color: #ffffff;
    font-size: 0.24rem;
    line-height: 1.4;
    cursor: pointer;
    backdrop-filter: blur(4px);
}

.hero-logo {
    position: relative;
    z-index: 1;
    display: block;
    width: 40%;
    height: auto;
    margin: calc(0.3rem + env(safe-area-inset-top, 0px)) 0.4rem 0;
}

.hero-title {
    position: relative;
    z-index: 1;
    margin: 0;
    padding: 0.24rem 0.4rem 0;
    font-size: 0.36rem;
    font-weight: 600;
    color: #ffffff;
    letter-spacing: 0.01rem;
    text-shadow: 0 0.02rem 0.12rem rgba(0, 0, 0, 0.25);
}

.panel {
    position: relative;
    z-index: 2;
    margin: -0.72rem 0.28rem 0;
}

.panel-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 0.96rem;
    padding: 0 0.32rem;
    margin-bottom: 0.2rem;
    background: #ffffff;
    border-radius: 0.28rem;
    box-shadow: 0 0.08rem 0.24rem rgba(40, 90, 160, 0.06);
}

.panel-title {
    font-size: 0.3rem;
    font-weight: 600;
    color: #1e3a5f;
}

.panel-link {
    display: inline-flex;
    align-items: center;
    border: none;
    background: transparent;
    color: #2b7de9;
    font-size: 0.26rem;
    padding: 0;
    cursor: pointer;
}

.panel-link-arrow {
    margin-left: 0.02rem;
    font-size: 0.32rem;
    line-height: 1;
    font-weight: 400;
}

.room-card {
    display: flex;
    padding: 0.24rem;
    margin-bottom: 0.2rem;
    background: #ffffff;
    border-radius: 0.24rem;
    box-shadow: 0 0.08rem 0.24rem rgba(40, 90, 160, 0.06);
    box-sizing: border-box;
}

.room-cover {
    width: 1.72rem;
    height: 1.72rem;
    border-radius: 0.16rem;
    object-fit: cover;
    flex-shrink: 0;
    background: #d9e6f5;
}

.room-body {
    flex: 1;
    min-width: 0;
    margin-left: 0.2rem;
    display: flex;
    flex-direction: column;
}

.room-name {
    font-size: 0.3rem;
    font-weight: 700;
    color: #1e3a5f;
    line-height: 1.3;
}

.room-meta {
    margin-top: 0.06rem;
    font-size: 0.22rem;
    color: #303133;
    line-height: 1.35;
}

.room-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 0.1rem;
    margin-top: 0.12rem;
}

.room-tag {
    padding: 0.02rem 0.12rem;
    border: 1px solid #f0c48a;
    border-radius: 0.2rem;
    color: #d4923a;
    font-size: 0.2rem;
    line-height: 1.5;
}

.room-bottom {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    margin-top: auto;
    padding-top: 0.12rem;
}

.room-price {
    display: flex;
    align-items: baseline;
    flex-wrap: wrap;
    gap: 0.08rem;
}

.price-origin {
    font-size: 0.22rem;
    color: #9aa8bc;
    text-decoration: line-through;
    line-height: 1;
}

.price-discount {
    font-size: 0.22rem;
    color: #9aa8bc;
}

.price-now {
    font-size: 0.32rem;
    font-weight: 700;
    color: #e2554a;
    line-height: 1;
}

.book-btn {
    border: none;
    background: transparent;
    color: #2b7de9;
    font-size: 0.26rem;
    padding: 0;
    white-space: nowrap;
    cursor: pointer;
}

.book-arrow {
    margin-left: 0.02rem;
    font-size: 0.3rem;
}

.empty {
    padding: 0.8rem 0;
    text-align: center;
    font-size: 0.26rem;
    color: #909399;
}
</style>
